import {useCallback, useEffect, useState} from "react";
import {
    blockFinanceiroLicenca,
    cancelFinanceiroBoleto,
    createFinanceiroBoleto,
    createFinanceiroContaBancaria,
    generateFinanceiroFatura,
    getFinanceiroBoleto,
    getFinanceiroBoletoHistorico,
    getFinanceiroBoletoPdf,
    getFinanceiroContaReceber,
    getFinanceiroContaReceberHistorico,
    getFinanceiroDashboard,
    getFinanceiroFaturaDetails,
    listEmpresasFinanceiroReference,
    listFinanceiroBoletos,
    listFinanceiroContasBancarias,
    listFinanceiroContasReceber,
    listFinanceiroFaturas,
    listFinanceiroInadimplencia,
    notifyFinanceiroFatura,
    reactivateFinanceiroLicenca,
    reprocessFinanceiroFatura,
    resendFinanceiroBoletoEmail,
    testFinanceiroContaBancaria,
    updateFinanceiroContaBancaria,
    deleteFinanceiroContaBancaria, listFinanceiroBanco, updateFinanceiroBanco, createFinanceiroBanco,
    deleteFinanceiroBanco, listFinanceiroFormasPagamento, updateFinanceiroFormasPagamento,
    createFinanceiroFormasPagamento, deleteFinanceiroFormasPagamento,
} from "./FinanceiroService";
import {
    extractFinanceiroListPayload,
    extractFinanceiroPagePayload,
    getBackendMessage,
    mapBankAccountFormToPayload, mapBankFormToPayload,
    mapCreateBoletoPayload, mapPaymentMethodsFormToPayload, normalizeFinanceiroBank,
    normalizeFinanceiroBankAccount,
    normalizeFinanceiroBoleto,
    normalizeFinanceiroBoletoHistory,
    normalizeFinanceiroDashboard,
    normalizeFinanceiroFatura,
    normalizeFinanceiroFaturaDetails,
    normalizeFinanceiroInadimplencia, normalizeFinanceiroPaymentMethods,
    normalizeFinanceiroReceivable,
    normalizeFinanceiroReceivableHistory,
    normalizeOperationResult,
    resolveUsuarioId,
} from "./financeiroUtils";
import {useAuth} from "../../shared/auth/AuthContext";
import {createEmptyFeedback, createEmptyPagination} from "../../shared/utils/payload";
import {useDebounce} from "../../shared/hooks";

export const useFinanceiro = () => {
    const {userLogged} = useAuth();
    const usuarioId = resolveUsuarioId(userLogged);
    const [dashboard, setDashboard] = useState(normalizeFinanceiroDashboard());
    const [empresas, setEmpresas] = useState([]);
    const [faturas, setFaturas] = useState([]);
    const [faturasPagination, setFaturasPagination] = useState(createEmptyPagination());
    const [inadimplentes, setInadimplentes] = useState([]);
    const [selectedFaturaDetails, setSelectedFaturaDetails] = useState(null);
    const [feedback, setFeedback] = useState(createEmptyFeedback());
    const [loadingDashboard, setLoadingDashboard] = useState(false);
    const [loadingFaturas, setLoadingFaturas] = useState(false);
    const [loadingInadimplencia, setLoadingInadimplencia] = useState(false);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [saving, setSaving] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const [banks, setBanks] = useState([]);
    const [banksPagination, setBanksPagination] = useState(createEmptyPagination());
    const [banksLoading, setBanksLoading] = useState(false);
    const [bankFilter, setBankFilter] = useState('');
    const [bankSearch, setBankSearch] = useState('');
    const [bankPage, setBankPage] = useState(0);
    const [bankPageSize, setBankPageSize] = useState(10);

    const [paymentMethods, setPaymentMethods] = useState([]);
    const [paymentMethodsPagination, setPaymentMethodsPagination] = useState(createEmptyPagination());
    const [paymentMethodsLoading, setPaymentMethodsLoading] = useState(false);
    const [paymentMethodsFilter, setPaymentMethodsFilter] = useState('');
    const [paymentMethodsSearch, setPaymentMethodsSearch] = useState('');
    const [paymentMethodsPage, setPaymentMethodsPage] = useState(0);
    const [paymentMethodsPageSize, setPaymentMethodsPageSize] = useState(10);

    const [bankAccounts, setBankAccounts] = useState([]);
    const [bankAccountsPagination, setBankAccountsPagination] = useState(createEmptyPagination());
    const [bankAccountsLoading, setBankAccountsLoading] = useState(false);
    const [bankAccountFilter, setBankAccountFilter] = useState('');
    const [bankAccountSearch, setBankAccountSearch] = useState('');
    const [bankAccountPage, setBankAccountPage] = useState(0);
    const [bankAccountPageSize, setBankAccountPageSize] = useState(10);
    const [bankOptions, setBankOptions] = useState([]);
    const [bankOptionsLoading, setBankOptionsLoading] = useState(false);
    const [bankOptionsSearch, setBankOptionsSearch] = useState('');

    const [boletos, setBoletos] = useState([]);
    const [boletosPagination, setBoletosPagination] = useState(createEmptyPagination());
    const [boletosLoading, setBoletosLoading] = useState(false);
    const [boletosStatusFilter, setBoletosStatusFilter] = useState('');
    const [boletosEmpresaFilter, setBoletosEmpresaFilter] = useState('');
    const [boletosSearch, setBoletosSearch] = useState('');
    const [boletosPage, setBoletosPage] = useState(0);
    const [selectedBoletoDetails, setSelectedBoletoDetails] = useState(null);
    const [selectedBoletoHistory, setSelectedBoletoHistory] = useState([]);
    const [boletoDetailsLoading, setBoletoDetailsLoading] = useState(false);

    const [receivables, setReceivables] = useState([]);
    const [receivablesPagination, setReceivablesPagination] = useState(createEmptyPagination());
    const [receivablesLoading, setReceivablesLoading] = useState(false);
    const [receivablesStatusFilter, setReceivablesStatusFilter] = useState('');
    const [receivablesEmpresaFilter, setReceivablesEmpresaFilter] = useState('');
    const [receivablesCompetenciaFilter, setReceivablesCompetenciaFilter] = useState('');
    const [receivablesSearch, setReceivablesSearch] = useState('');
    const [receivablesPage, setReceivablesPage] = useState(0);
    const [selectedReceivableDetails, setSelectedReceivableDetails] = useState(null);
    const [selectedReceivableHistory, setSelectedReceivableHistory] = useState([]);
    const [receivableDetailsLoading, setReceivableDetailsLoading] = useState(false);
    const debouncedBankSearch = useDebounce(bankSearch, 400);
    const debouncedPaymentMethodsSearch = useDebounce(paymentMethodsSearch, 600);
    const debouncedBankAccountSearch = useDebounce(bankAccountSearch, 400);
    const debouncedBankOptionsSearch = useDebounce(bankOptionsSearch, 600);
    const debouncedBoletosSearch = useDebounce(boletosSearch, 400);
    const debouncedReceivablesSearch = useDebounce(receivablesSearch, 400);

    const clearFeedback = useCallback(() => {
        setFeedback(createEmptyFeedback());
    }, []);

    const changeBoletosSearch = useCallback((value) => {
        setBoletosSearch(value);
        setBoletosPage(0);
    }, []);

    const changeBankSearch = useCallback((value) => {
        setBankSearch(value);
        setBankPage(0);
    }, []);

    const changePaymentMethodsSearch = useCallback((value) => {
        setPaymentMethodsSearch(value);
        setPaymentMethodsPage(0);
    }, []);

    const changeBankAccountSearch = useCallback((value) => {
        setBankAccountSearch(value);
        setBankAccountPage(0);
    }, []);

    const changeReceivablesSearch = useCallback((value) => {
        setReceivablesSearch(value);
        setReceivablesPage(0);
    }, []);

    const loadEmpresas = useCallback(async () => {
        try {
            const response = await listEmpresasFinanceiroReference();
            const payload = response?.data?.valor ?? response?.data?.data ?? response?.data ?? {};
            const items = Array.isArray(payload?.items)
                ? payload.items
                : Array.isArray(payload?.content)
                    ? payload.content
                    : Array.isArray(payload)
                        ? payload
                        : [];
            setEmpresas(items);
        } catch {
            setEmpresas([]);
        }
    }, []);

    const loadDashboard = useCallback(async () => {
        setLoadingDashboard(true);
        try {
            const response = await getFinanceiroDashboard();
            const payload = response?.data?.data ?? response?.data ?? {};
            setDashboard(normalizeFinanceiroDashboard(payload));
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar o dashboard financeiro.'), success: ''});
        } finally {
            setLoadingDashboard(false);
        }
    }, []);

    const loadFaturas = useCallback(async () => {
        setLoadingFaturas(true);
        try {
            const response = await listFinanceiroFaturas({
                status: statusFilter,
                page,
                page_size: pageSize,
            });
            const payload = extractFinanceiroListPayload(response);
            setFaturas(payload.items.map((item) => normalizeFinanceiroFatura(item)));
            setFaturasPagination(payload.pagination);
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar as faturas.'), success: ''});
        } finally {
            setLoadingFaturas(false);
        }
    }, [page, pageSize, statusFilter]);

    const loadInadimplencia = useCallback(async () => {
        setLoadingInadimplencia(true);
        try {
            const response = await listFinanceiroInadimplencia();
            const payload = extractFinanceiroListPayload(response);
            setInadimplentes(normalizeFinanceiroInadimplencia(payload.items));
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar a inadimplência.'), success: ''});
        } finally {
            setLoadingInadimplencia(false);
        }
    }, []);

    const loadBankAccounts = useCallback(async () => {
        setBankAccountsLoading(true);
        try {
            const response = await listFinanceiroContasBancarias({
                status: bankAccountFilter || undefined,
                apelido: debouncedBankAccountSearch.trim() || undefined,
                page: bankAccountPage,
                size: bankAccountPageSize,
            });
            const payload = extractFinanceiroPagePayload(response);
            setBankAccounts(payload.items.map((item) => normalizeFinanceiroBankAccount(item)));
            setBankAccountsPagination(payload.pagination);
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar as contas bancárias.'), success: ''});
        } finally {
            setBankAccountsLoading(false);
        }
    }, [bankAccountFilter, bankAccountPage, bankAccountPageSize, debouncedBankAccountSearch]);

    const loadBanks = useCallback(async () => {
        setBanksLoading(true);
        try {
            const response = await listFinanceiroBanco({
                status: bankFilter || undefined,
                nomeComercial: debouncedBankSearch.trim() || undefined,
                page: bankPage,
                size: bankPageSize,
            });
            const payload = extractFinanceiroPagePayload(response);
            setBanks(payload.items.map((item) => normalizeFinanceiroBank(item)));
            setBanksPagination(payload.pagination);
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar a lista de bancos.'), success: ''});
        } finally {
            setBanksLoading(false);
        }
    }, [bankFilter, bankPage, bankPageSize, debouncedBankSearch]);

    const loadPaymentMethods = useCallback(async () => {
        setPaymentMethodsLoading(true);
        try {
            const response = await listFinanceiroFormasPagamento({
                status: paymentMethodsFilter || undefined,
                nome: debouncedPaymentMethodsSearch.trim() || undefined,
                page: paymentMethodsPage,
                size: paymentMethodsPageSize,
            });
            const payload = extractFinanceiroPagePayload(response);
            setPaymentMethods(payload.items.map((item) => normalizeFinanceiroPaymentMethods(item)));
            setPaymentMethodsPagination(payload.pagination);
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar a lista de formas de pagamento.'), success: ''});
        } finally {
            setPaymentMethodsLoading(false);
        }
    }, [paymentMethodsFilter, paymentMethodsPage, paymentMethodsPageSize, debouncedPaymentMethodsSearch]);

    const loadBankOptions = useCallback(async () => {
        setBankOptionsLoading(true);
        try {
            const response = await listFinanceiroBanco({
                nomeComercial: debouncedBankOptionsSearch.trim() || undefined,
                page: 0,
                size: 10,
            });
            const payload = extractFinanceiroPagePayload(response);
            setBankOptions(payload.items.map((item) => normalizeFinanceiroBank(item)));
        } catch {
            setBankOptions([]);
        } finally {
            setBankOptionsLoading(false);
        }
    }, [debouncedBankOptionsSearch]);

    const loadBoletos = useCallback(async () => {
        setBoletosLoading(true);
        try {
            const response = await listFinanceiroBoletos({
                id_empresa: boletosEmpresaFilter || undefined,
                status: boletosStatusFilter || undefined,
                nossoNumero: debouncedBoletosSearch.trim() || undefined,
                page: boletosPage,
                size: 10,
            });
            const payload = extractFinanceiroPagePayload(response);
            setBoletos(payload.items.map((item) => normalizeFinanceiroBoleto(item)));
            setBoletosPagination(payload.pagination);
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar os boletos.'), success: ''});
        } finally {
            setBoletosLoading(false);
        }
    }, [boletosEmpresaFilter, boletosPage, boletosStatusFilter, debouncedBoletosSearch]);

    const loadReceivables = useCallback(async () => {
        setReceivablesLoading(true);
        try {
            const response = await listFinanceiroContasReceber({
                id_empresa: receivablesEmpresaFilter || undefined,
                status: receivablesStatusFilter || undefined,
                competencia: receivablesCompetenciaFilter || undefined,
                descricao: debouncedReceivablesSearch.trim() || undefined,
                page: receivablesPage,
                size: 10,
            });
            const payload = extractFinanceiroPagePayload(response);
            setReceivables(payload.items.map((item) => normalizeFinanceiroReceivable(item)));
            setReceivablesPagination(payload.pagination);
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar as contas a receber.'), success: ''});
        } finally {
            setReceivablesLoading(false);
        }
    }, [debouncedReceivablesSearch, receivablesCompetenciaFilter, receivablesEmpresaFilter, receivablesPage, receivablesStatusFilter]);

    useEffect(() => {
        loadEmpresas();
    }, [loadEmpresas]);

    useEffect(() => {
        loadDashboard();
    }, [loadDashboard]);

    useEffect(() => {
        loadInadimplencia();
    }, [loadInadimplencia]);

    useEffect(() => {
        loadFaturas();
    }, [loadFaturas]);

    useEffect(() => {
        loadBanks();
    }, [loadBanks]);

    useEffect(() => {
        loadPaymentMethods();
    }, [loadPaymentMethods]);

    useEffect(() => {
        loadBankAccounts();
    }, [loadBankAccounts]);

    useEffect(() => {
        loadBankOptions();
    }, [loadBankOptions]);

    useEffect(() => {
        loadBoletos();
    }, [loadBoletos]);

    useEffect(() => {
        loadReceivables();
    }, [loadReceivables]);

    const reloadAll = useCallback(async () => {
        await Promise.all([
            loadDashboard(),
            loadFaturas(),
            loadInadimplencia(),
            loadBanks(),
            loadPaymentMethods(),
            loadBankAccounts(),
            loadBoletos(),
            loadReceivables(),
        ]);
    }, [loadBanks, loadPaymentMethods, loadBankAccounts, loadBoletos, loadDashboard, loadFaturas, loadInadimplencia, loadReceivables]);

    const openFaturaDetails = useCallback(async (faturaId) => {
        if (!faturaId) return;

        setLoadingDetails(true);
        try {
            const response = await getFinanceiroFaturaDetails(faturaId);
            const payload = response?.data?.data ?? response?.data ?? {};
            setSelectedFaturaDetails(normalizeFinanceiroFaturaDetails(payload));
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar os detalhes da fatura.'), success: ''});
        } finally {
            setLoadingDetails(false);
        }
    }, []);

    const closeFaturaDetails = useCallback(() => {
        setSelectedFaturaDetails(null);
    }, []);

    const createFatura = useCallback(async (payload) => {
        setSaving(true);
        try {
            await generateFinanceiroFatura(payload);
            setFeedback({error: '', success: 'Solicitação de geração enviada com sucesso.'});
            await reloadAll();
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível solicitar a geração da fatura.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [reloadAll]);

    const reprocessInvoice = useCallback(async (faturaId) => {
        if (!faturaId) return false;

        setSaving(true);
        try {
            await reprocessFinanceiroFatura(faturaId);
            setFeedback({error: '', success: 'Reprocessamento solicitado com sucesso.'});
            await reloadAll();
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível reprocessar a fatura.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [reloadAll]);

    const notifyCollection = useCallback(async (faturaId) => {
        if (!faturaId) return false;

        setSaving(true);
        try {
            await notifyFinanceiroFatura(faturaId);
            setFeedback({error: '', success: 'Notificação de cobrança enviada com sucesso.'});
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível reenviar a notificação de cobrança.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, []);

    const blockLicense = useCallback(async (licencaId) => {
        if (!licencaId) return false;

        setSaving(true);
        try {
            await blockFinanceiroLicenca(licencaId);
            setFeedback({error: '', success: 'Licença bloqueada com sucesso.'});
            await reloadAll();
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível bloquear a licença.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [reloadAll]);

    const reactivateLicense = useCallback(async (licencaId) => {
        if (!licencaId) return false;

        setSaving(true);
        try {
            await reactivateFinanceiroLicenca(licencaId);
            setFeedback({error: '', success: 'Licença reativada com sucesso.'});
            await reloadAll();
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível reativar a licença.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [reloadAll]);

    const saveBankAccount = useCallback(async (values, bankAccountId = '') => {
        setSaving(true);
        try {
            const payload = mapBankAccountFormToPayload(values, usuarioId);
            if (bankAccountId) {
                await updateFinanceiroContaBancaria(bankAccountId, payload);
            } else {
                await createFinanceiroContaBancaria(payload);
            }
            setFeedback({error: '', success: bankAccountId ? 'Conta bancária atualizada com sucesso.' : 'Conta bancária criada com sucesso.'});
            await loadBankAccounts();
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível salvar a conta bancária.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [loadBankAccounts, usuarioId]);

    const removeBankAccount = useCallback(async (bankAccountId) => {
        if (!bankAccountId || !usuarioId) return false;

        setSaving(true);
        try {
            await deleteFinanceiroContaBancaria(bankAccountId, usuarioId);
            setFeedback({error: '', success: 'Conta bancária removida com sucesso.'});
            await loadBankAccounts();
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível excluir a conta bancária.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [loadBankAccounts, usuarioId]);

    const validateBankConnection = useCallback(async (bankAccountId) => {
        if (!bankAccountId) return false;

        setSaving(true);
        try {
            const response = await testFinanceiroContaBancaria(bankAccountId);
            const result = normalizeOperationResult(response?.data ?? {});
            setFeedback({error: result.success ? '' : result.message, success: result.success ? (result.message || 'Conexão validada com sucesso.') : ''});
            return result.success;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível testar a conexão bancária.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, []);

    const saveBank = useCallback(async (values, bankId = '') => {
        setSaving(true);
        try {
            const payload = mapBankFormToPayload(values, usuarioId);
            if (bankId) {
                await updateFinanceiroBanco(bankId, payload);
            } else {
                await createFinanceiroBanco(payload);
            }
            setFeedback({error: '', success: bankId ? 'Banco atualizado com sucesso.' : 'Banco cadastrado com sucesso.'});
            await loadBanks();
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível salvar os dados do banco.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [loadBanks, usuarioId]);

    const removeBank = useCallback(async (bankId) => {
        if (!bankId) return false;

        setSaving(true);
        try {
            await deleteFinanceiroBanco(bankId);
            setFeedback({error: '', success: 'Banco removido com sucesso.'});
            await loadBanks();
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível excluir os dados do banco.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [loadBanks]);

    const savePaymentMethods = useCallback(async (values, formaPagamentoId = '') => {
        setSaving(true);
        try {
            const payload = mapPaymentMethodsFormToPayload(values, usuarioId);
            if (formaPagamentoId) {
                await updateFinanceiroFormasPagamento(formaPagamentoId, payload);
            } else {
                await createFinanceiroFormasPagamento(payload);
            }
            setFeedback({error: '', success: formaPagamentoId ? 'Forma de pagamento atualizado com sucesso.' : 'Forma de Pagamento cadastrado com sucesso.'});
            await loadPaymentMethods();
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível salvar os dados da forma de pagamento.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [loadPaymentMethods, usuarioId]);

    const removePaymentMethods = useCallback(async (formaPagamentoId) => {
        if (!formaPagamentoId) return false;

        setSaving(true);
        try {
            await deleteFinanceiroFormasPagamento(formaPagamentoId);
            setFeedback({error: '', success: 'Forma de pagamento removido com sucesso.'});
            await loadPaymentMethods();
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível excluir os dados do banco.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [loadPaymentMethods]);

    const openBoletoDetails = useCallback(async (boletoId) => {
        if (!boletoId) return;

        setBoletoDetailsLoading(true);
        try {
            const [boletoResponse, historyResponse] = await Promise.all([
                getFinanceiroBoleto(boletoId),
                getFinanceiroBoletoHistorico(boletoId),
            ]);
            setSelectedBoletoDetails(normalizeFinanceiroBoleto(boletoResponse?.data?.data ?? boletoResponse?.data ?? {}));
            const historyPayload = historyResponse?.data?.data ?? historyResponse?.data ?? [];
            setSelectedBoletoHistory(normalizeFinanceiroBoletoHistory(Array.isArray(historyPayload) ? historyPayload : historyPayload?.items || []));
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar os detalhes do boleto.'), success: ''});
        } finally {
            setBoletoDetailsLoading(false);
        }
    }, []);

    const closeBoletoDetails = useCallback(() => {
        setSelectedBoletoDetails(null);
        setSelectedBoletoHistory([]);
    }, []);

    const createBoleto = useCallback(async (values) => {
        setSaving(true);
        try {
            await createFinanceiroBoleto(mapCreateBoletoPayload(values, usuarioId));
            setFeedback({error: '', success: 'Boleto gerado com sucesso.'});
            await Promise.all([loadBoletos(), loadReceivables()]);
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível gerar o boleto.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [loadBoletos, loadReceivables, usuarioId]);

    const cancelBoleto = useCallback(async (boletoId, motivo) => {
        if (!boletoId || !usuarioId) return false;

        setSaving(true);
        try {
            await cancelFinanceiroBoleto(boletoId, {motivo, usuarioId});
            setFeedback({error: '', success: 'Boleto cancelado com sucesso.'});
            await Promise.all([loadBoletos(), loadReceivables()]);
            return true;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível cancelar o boleto.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, [loadBoletos, loadReceivables, usuarioId]);

    const resendBoletoEmail = useCallback(async (boletoId) => {
        if (!boletoId) return false;

        setSaving(true);
        try {
            const response = await resendFinanceiroBoletoEmail(boletoId);
            const result = normalizeOperationResult(response?.data ?? {});
            setFeedback({error: result.success ? '' : result.message, success: result.success ? (result.message || 'E-mail reenviado com sucesso.') : ''});
            return result.success;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível reenviar o boleto por e-mail.'), success: ''});
            return false;
        } finally {
            setSaving(false);
        }
    }, []);

    const requestBoletoPdf = useCallback(async (boleto) => {
        if (!boleto?.id) return null;

        if (boleto?.urlPdf) {
            return {success: true, url: boleto.urlPdf, message: ''};
        }

        setSaving(true);
        try {
            const response = await getFinanceiroBoletoPdf(boleto.id);
            const result = normalizeOperationResult(response?.data ?? {});
            if (result.success) {
                setFeedback({error: '', success: result.message || 'PDF do boleto solicitado com sucesso.'});
            } else {
                setFeedback({error: result.message || 'Não foi possível obter o PDF do boleto.', success: ''});
            }
            return result;
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível obter o PDF do boleto.'), success: ''});
            return null;
        } finally {
            setSaving(false);
        }
    }, []);

    const openReceivableDetails = useCallback(async (receivableId) => {
        if (!receivableId) return;

        setReceivableDetailsLoading(true);
        try {
            const [detailResponse, historyResponse] = await Promise.all([
                getFinanceiroContaReceber(receivableId),
                getFinanceiroContaReceberHistorico(receivableId),
            ]);
            setSelectedReceivableDetails(normalizeFinanceiroReceivable(detailResponse?.data?.data ?? detailResponse?.data ?? {}));
            const historyPayload = historyResponse?.data?.data ?? historyResponse?.data ?? [];
            setSelectedReceivableHistory(normalizeFinanceiroReceivableHistory(Array.isArray(historyPayload) ? historyPayload : historyPayload?.items || []));
        } catch (error) {
            setFeedback({error: getBackendMessage(error, 'Não foi possível carregar os detalhes da conta a receber.'), success: ''});
        } finally {
            setReceivableDetailsLoading(false);
        }
    }, []);

    const closeReceivableDetails = useCallback(() => {
        setSelectedReceivableDetails(null);
        setSelectedReceivableHistory([]);
    }, []);

    return {
        dashboard,
        empresas,
        faturas,
        faturasPagination,
        inadimplentes,
        selectedFaturaDetails,
        feedback,
        loadingDashboard,
        loadingFaturas,
        loadingInadimplencia,
        loadingDetails,
        saving,
        statusFilter,
        page,
        pageSize,
        paymentMethods,
        paymentMethodsPagination,
        paymentMethodsLoading,
        paymentMethodsSearch,
        paymentMethodsFilter,
        paymentMethodsPage,
        paymentMethodsPageSize,
        banks,
        banksPagination,
        banksLoading,
        bankFilter,
        bankSearch,
        bankPage,
        bankPageSize,
        bankAccounts,
        bankAccountsPagination,
        bankAccountsLoading,
        bankAccountFilter,
        bankAccountSearch,
        bankAccountPage,
        bankAccountPageSize,
        bankOptions,
        bankOptionsLoading,
        bankOptionsSearch,
        boletos,
        boletosPagination,
        boletosLoading,
        boletosStatusFilter,
        boletosEmpresaFilter,
        boletosSearch,
        boletosPage,
        selectedBoletoDetails,
        selectedBoletoHistory,
        boletoDetailsLoading,
        receivables,
        receivablesPagination,
        receivablesLoading,
        receivablesStatusFilter,
        receivablesEmpresaFilter,
        receivablesCompetenciaFilter,
        receivablesSearch,
        receivablesPage,
        selectedReceivableDetails,
        selectedReceivableHistory,
        receivableDetailsLoading,
        setFeedback,
        clearFeedback,
        setStatusFilter,
        setPage,
        setPageSize,
        setPaymentMethodsFilter,
        setPaymentMethodsSearch: changePaymentMethodsSearch,
        setPaymentMethodsPage,
        setPaymentMethodsPageSize,
        setBankFilter,
        setBankSearch: changeBankSearch,
        setBankPage,
        setBankPageSize,
        setBankAccountFilter,
        setBankAccountSearch: changeBankAccountSearch,
        setBankAccountPage,
        setBankAccountPageSize,
        setBankOptionsSearch,
        setBoletosStatusFilter,
        setBoletosEmpresaFilter,
        setBoletosSearch: changeBoletosSearch,
        setBoletosPage,
        setReceivablesStatusFilter,
        setReceivablesEmpresaFilter,
        setReceivablesCompetenciaFilter,
        setReceivablesSearch: changeReceivablesSearch,
        setReceivablesPage,
        openFaturaDetails,
        closeFaturaDetails,
        createFatura,
        reprocessInvoice,
        blockLicense,
        reactivateLicense,
        notifyCollection,
        saveBank,
        removeBank,
        savePaymentMethods,
        removePaymentMethods,
        saveBankAccount,
        removeBankAccount,
        validateBankConnection,
        createBoleto,
        cancelBoleto,
        resendBoletoEmail,
        requestBoletoPdf,
        openBoletoDetails,
        closeBoletoDetails,
        openReceivableDetails,
        closeReceivableDetails,
        reloadDashboard: loadDashboard,
        reloadFaturas: loadFaturas,
        reloadInadimplencia: loadInadimplencia,
        reloadBankAccounts: loadBankAccounts,
        reloadBoletos: loadBoletos,
        reloadReceivables: loadReceivables,
    };
};
